var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var ValidatorMapping = /** @class */ (function () {
    function ValidatorMapping(validators) {
        this.validators = validators;
    }
    /**
     * Map the given property mapping to an object representing the validations per property
     *
     * @param propertyMapping A property mapping that was created using the propertyMapping(...) function
     */
    ValidatorMapping.prototype.mapPropertyMapping = function (propertyMapping) {
        var e_1, _a;
        var result = {};
        try {
            for (var _b = __values(propertyMapping.properties), _c = _b.next(); !_c.done; _c = _b.next()) {
                var property = _c.value;
                result[property.name] = this.mapMaybeNestedProperty(property);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return result;
    };
    /**
     * Recursively maps the given property to a validator map
     *
     * @param property A simple or a nested property
     */
    ValidatorMapping.prototype.mapMaybeNestedProperty = function (property) {
        var e_2, _a;
        var mapped = {};
        if (property.type === 'nested' || property.type === 'array') {
            try {
                for (var _b = __values(property.properties), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var nestedProperty = _c.value;
                    mapped[nestedProperty.name] = this.mapMaybeNestedProperty(nestedProperty);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        else if (property.type === 'simple') {
            // Simple property with validations
            if (hasValidations(property)) {
                mapped = this.mapSimpleProperty(property);
            }
        }
        return mapped;
    };
    /**
     * Map a simple property to a validator map
     *
     * @param property A property that contains a map of validations
     */
    ValidatorMapping.prototype.mapSimpleProperty = function (property) {
        var e_3, _a;
        var _b;
        var validations = property.validations;
        var mappedValidations = {};
        try {
            for (var validations_1 = __values(validations), validations_1_1 = validations_1.next(); !validations_1_1.done; validations_1_1 = validations_1.next()) {
                var validator = validations_1_1.value;
                mappedValidations[validator.validatorName] = this.mapValidator.apply(this, __spread([validator.validatorName], (_b = validator.validatorArguments, (_b !== null && _b !== void 0 ? _b : []))));
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (validations_1_1 && !validations_1_1.done && (_a = validations_1.return)) _a.call(validations_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return mappedValidations;
    };
    /**
     * Map a specific validator
     *
     * @param name Name of the validator
     * @param args Possible arguments for the validator
     */
    ValidatorMapping.prototype.mapValidator = function (name) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var validator = this.validators[name];
        if (validator == null) {
            throw new Error("No validator mapping found for " + name);
        }
        return validator.apply(void 0, __spread(args));
    };
    return ValidatorMapping;
}());
export { ValidatorMapping };
/**
 * Check if the given property contains a map of validations
 *
 * @param property Any type of property
 */
function hasValidations(property) {
    return property.validations !== undefined;
}
//# sourceMappingURL=validator-mapping.js.map